module.exports = {
    howler: [
        "res/sounds/lines/lines_0",
        "res/sounds/lines/lines_1",
        "res/sounds/lines/lines_2",
        "res/sounds/lines/lines_3",
        "res/sounds/lines/lines_4",
        "res/sounds/bet_up",
        "res/sounds/bet_down",
        "res/sounds/credits",
        "res/sounds/winflow",
        "res/sounds/clock_tick",

        "res/sounds/spin/spin_0",
        "res/sounds/spin/spin_1",
        "res/sounds/spin/spin_2",

        "res/sounds/bar_stop/bar_stop_0",
        "res/sounds/bar_stop/bar_stop_1",
        "res/sounds/bar_stop/bar_stop_2",
        "res/sounds/bar_stop/bar_stop_3",
        "res/sounds/bar_stop/bar_stop_4",

        "res/sounds/scatters/scatter_0",
        "res/sounds/scatters/scatter_1",
        "res/sounds/scatters/scatter_2",
        "res/sounds/scatters/scatter_3",
        "res/sounds/scatters/scatter_4",

        "res/sounds/doublegame/risk_lose",
        "res/sounds/doublegame/risk_win",
        "res/sounds/doublegame/rotate",
        "res/sounds/doublegame/risk_background",

        "res/sounds/help/click",
        "res/sounds/help/help_music",
        "res/sounds/help/help_enter",
        "res/sounds/help/help_exit",

        "res/sounds/symbols/symbol_0",
        "res/sounds/symbols/symbol_1",
        "res/sounds/symbols/symbol_2",
        "res/sounds/symbols/symbol_3",
        "res/sounds/symbols/symbol_4",
        "res/sounds/symbols/symbol_5",
        "res/sounds/symbols/symbol_6",
        "res/sounds/symbols/symbol_7",
        "res/sounds/symbols/symbol_8",
        "res/sounds/symbols/symbol_9",
        "res/sounds/symbols/symbol_10",
        "res/sounds/symbols/symbol_11",

        "res/sounds/show_table",
        "res/sounds/bonus/bonus_show_win",
        "res/sounds/bonus/monster_fight_end",
        "res/sounds/bonus/monster_fight_start",
        "res/sounds/bonus/monster_show",
        "res/sounds/bonus/puddle",
        "res/sounds/bonus/select_cell",
        "res/sounds/bonus/show_cell",
        "res/sounds/bonus/vortex",
        "res/sounds/bonus/boat_reset",
        "res/sounds/bonus/transition_to_super",
        "res/sounds/bonus/bonus_flow_start",
        "res/sounds/bonus/bonus_flow",

        "res/sounds/super_bonus/super_bonus_choice",
        "res/sounds/super_bonus/super_bonus_music",
        "res/sounds/super_bonus/trader_lose",
        "res/sounds/super_bonus/trader_win",
        "res/sounds/super_bonus/prizes/prize_lose_0",
        "res/sounds/super_bonus/prizes/prize_lose_1",
        "res/sounds/super_bonus/prizes/prize_lose_2",
        "res/sounds/super_bonus/prizes/prize_lose_3",
        "res/sounds/super_bonus/prizes/prize_lose_4",
        "res/sounds/super_bonus/prizes/prize_lose_5",
        "res/sounds/super_bonus/prizes/prize_lose_6",
        "res/sounds/super_bonus/prizes/prize_lose_7",
        "res/sounds/super_bonus/prizes/prize_win_0",
        "res/sounds/super_bonus/prizes/prize_win_1",
        "res/sounds/super_bonus/prizes/prize_win_2",
        "res/sounds/super_bonus/prizes/prize_win_3",
        "res/sounds/super_bonus/prizes/prize_win_4",
        "res/sounds/super_bonus/prizes/prize_win_5",
        "res/sounds/super_bonus/prizes/prize_win_6",
        "res/sounds/super_bonus/prizes/prize_win_7",

    ],
    //all other different resources (even those which configure the game logic) are able to be loaded with PIXI native loader:
    pixi: [
        "res/mainbackground.jpg",
        "res/lines_frames_billets0.json",
        "res/lines_frames_billets1.json",
        "res/reel_symbols.json",
        "res/blur_symbols.json",
        "res/symbol_animations0.json",
        "res/symbol_animations1.json",
        "res/symbol_animations2.json",
        "res/symbol_animations3.json",
        "res/symbol_animations4.json",
        "res/symbol_animations5.json",
        "res/symbol_animations6.json",
        "res/symbol_animations7.json",
        "res/symbol_animations8.json",
        "res/symbol_animations9.json",
        "res/symbol_animations10.json",
        "res/symbol_animations11.json",
        "res/symbol_animations12.json",
        "res/symbol_animations13.json",
        "res/symbol_animations14.json",
        "res/symbol_animations15.json",
        "res/symbol_animations16.json",
        "res/logo.png",
        "res/extra_life.png",
        "res/fonts/impact_font.xml",
        "res/fonts/impact_font.png",
        "res/fonts/price-font.xml",
        "res/fonts/price-font.png",
        "res/help/page_0.jpg",
        "res/help/page_1.jpg",
        "res/help/page_2.jpg",
        "res/help/page_3.jpg",
        "res/help/page_4.jpg",

        "res/sea_backgrounds/sea_background_0.jpg",
        "res/sea_backgrounds/sea_background_1.jpg",
        "res/sea_backgrounds/sea_background_2.jpg",
        "res/sea_backgrounds/sea_background_3.jpg",
        "res/sea_backgrounds/sea_background_4.jpg",

        "res/risk/fivecard_risk.json",
        "res/risk/cards0.json",
        "res/risk/cards1.json",
        "res/risk/cards2.json",
        "res/fonts/gamble_amount_font.xml",
        "res/fonts/gamble_to_win_font.xml",
        "res/fonts/gamble_iterator_font.xml",

        "res/bonus/bonus_tables.json",
        "res/bonus/bonus_grid.png",
        "res/bonus/bonus_boat0.json",
        "res/bonus/bonus_boat1.json",
        "res/bonus/bonus_cells0.json",
        "res/bonus/bonus_cells1.json",
        "res/bonus/bonus_fisher.json",
        "res/bonus/bonus_monster0.json",
        "res/bonus/bonus_monster1.json",
        "res/bonus/bonus_monster2.json",
        "res/bonus/bonus_monster3.json",
        "res/bonus/bonus_monster4.json",
        "res/bonus/bonus_whirlpool.json",
        "res/fonts/bonus_font.xml",
        "res/fonts/bonus_totalwin_font.xml",
        "res/fonts/bonus_table_font.xml",

        "res/superBonus/super_background.jpg",
        "res/superBonus/super_bonus.json",
        "res/superBonus/superbonus_prizes0.json",
        "res/superBonus/superbonus_prizes1.json",
        "res/superBonus/superbonus_prizes2.json",
        "res/superBonus/superbonus_prizes3.json",
        "res/superBonus/superbonus_prizes4.json",
        "res/superBonus/superbonus_prizes5.json",
        "res/superBonus/superbonus_prizes6.json",
        "res/superBonus/superbonus_prizes7.json",
        "res/superBonus/superbonus_prizes8.json",
        "res/superBonus/superbonus_prizes9.json",
        "res/superBonus/superbonus_prizes10.json",
        "res/superBonus/superbonus_prizes11.json",
        "res/superBonus/superbonus_prizes12.json",
        "res/superBonus/trader_animations0.json",
        "res/superBonus/trader_animations1.json",
        "res/superBonus/trader_animations2.json",
        "res/fonts/marker_font.xml",
        "res/fonts/super_bonus_win_font.xml",


    ]
};




//////////////////
// WEBPACK FOOTER
// ./res/resources.js
// module id = 85
// module chunks = 0